import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Flex } from '../Box';
import { P } from '../Text';

interface FormatMessageProps {
  id: string;
  defaultMessage: string;
  values?: Record<string, string | undefined>;
  isSubheader?: boolean;
}

type Props = {
  tableData: {
    headers: FormatMessageProps[];
    rows: FormatMessageProps[][];
  };
};

/**
 *
 */
export const Table = (props: Props) => {
  const { tableData } = props;
  return (
    <Flex>
      <Flex flexDirection="column">
        <Flex
          sx={{ borderBottom: '2px solid', borderColor: 'teal' }}
          alignItems="center"
        >
          {tableData.headers.map(({ id, defaultMessage }) => (
            <P
              key={id}
              color="teal"
              fontSize={14}
              fontWeight="bold"
              width={1 / 3}
              p="5px"
            >
              <FormattedMessage defaultMessage={defaultMessage} id={id} />
            </P>
          ))}
        </Flex>
        <Flex flexDirection="column">
          {tableData.rows.map((row) => (
            <React.Fragment key={row[0].id}>
              <Flex flexWrap="wrap">
                {row.map(({ id, defaultMessage, values, isSubheader }) =>
                  isSubheader ? (
                    <P
                      key={id}
                      color="gray30"
                      fontSize={12}
                      p="5px"
                      pb="10px"
                      fontWeight={500}
                    >
                      <FormattedMessage
                        defaultMessage={defaultMessage}
                        id={id}
                        values={values}
                      />
                    </P>
                  ) : (
                    <Flex alignItems="center" width={1 / 3} p="5px" key={id}>
                      <P color="gray50" fontSize={12}>
                        <FormattedMessage
                          defaultMessage={defaultMessage}
                          id={id}
                          values={values}
                        />
                      </P>
                    </Flex>
                  ),
                )}
              </Flex>
              {row.length > 1 && (
                <Box
                  height={1}
                  width="100%"
                  m="5px"
                  bg="gray10"
                  key={row[0].id}
                />
              )}
            </React.Fragment>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Table;
